export enum EFileType {
    BOARDUSERS_LIST = 0,
    AUTOMATION_SETTINGS = 1,
    USER_DATA = 2,
    IMAGE = 3,
    USER_SITE_FILE = 4,
    BOARDUSERSUSERS_TECHDUMP = 5,
    PERMISSION_LOGO = 6,
}

export enum USER_FILE_TABLE_COLUMNS {
    NAME = 'name',
    CREATED_AT = 'created_at',
    UPDATED_AT = 'updated_at',
    ACTIONS = 'actions'
}
export const USER_FILE_TABLE_HEADER = [
    USER_FILE_TABLE_COLUMNS.NAME,
    USER_FILE_TABLE_COLUMNS.CREATED_AT,
    USER_FILE_TABLE_COLUMNS.UPDATED_AT,
    USER_FILE_TABLE_COLUMNS.ACTIONS
];

export const USER_FILES_DEFAULT_SORT_COLUMN = USER_FILE_TABLE_COLUMNS.CREATED_AT;
export const USER_FILES_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const USER_FILES_PAGE_SIZE_OPTIONS = [5, 10];
export const USER_FILES_PAGE_DEFAULT_SIZE = 5;

export const ALLOWED_IMAGE_TYPES = ['image/png', 'image/jpg', 'image/jpeg'];
export const ALLOWED_FILE_TYPES = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'];

export const ALLOWED_FILE_SHARE_VCT_TYPE = ['text/csv'];

export const MAX_UPLOAD_SIZE = 909600;
